// extracted by mini-css-extract-plugin
module.exports = {"button":"_37J6z","fixedWidth":"wDnab","primary":"Nm4L1","large":"_3ypzk"};